export default __webpack_public_path__ + "static/media/helsinki_l.dea07bc9.jpg";